import { styled } from "@mui/material/styles";

const PageTitle = styled("h2")(`
  font-family: Inter;
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  color: #1F2635;
  margin: 70px auto 0px;
  width: 50%;
  line-height: 32px;
`);

export default PageTitle;
